function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z",
  fill: "#4BB34B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.197 12.5303C23.4899 12.2374 23.4899 11.7626 23.197 11.4697C22.9041 11.1768 22.4292 11.1768 22.1363 11.4697L23.197 12.5303ZM13.3333 21.3334L12.803 21.8637C13.0959 22.1566 13.5707 22.1566 13.8636 21.8637L13.3333 21.3334ZM9.86358 16.803C9.57069 16.5101 9.09581 16.5101 8.80292 16.803C8.51003 17.0959 8.51003 17.5708 8.80292 17.8637L9.86358 16.803ZM22.1363 11.4697L12.803 20.803L13.8636 21.8637L23.197 12.5303L22.1363 11.4697ZM8.80292 17.8637L12.803 21.8637L13.8636 20.803L9.86358 16.803L8.80292 17.8637ZM27.25 16C27.25 22.2132 22.2132 27.25 16 27.25V28.75C23.0416 28.75 28.75 23.0416 28.75 16H27.25ZM16 27.25C9.7868 27.25 4.75 22.2132 4.75 16H3.25C3.25 23.0416 8.95837 28.75 16 28.75V27.25ZM4.75 16C4.75 9.7868 9.7868 4.75 16 4.75V3.25C8.95837 3.25 3.25 8.95837 3.25 16H4.75ZM16 4.75C22.2132 4.75 27.25 9.7868 27.25 16H28.75C28.75 8.95837 23.0416 3.25 16 3.25V4.75Z",
  fill: "#4BB34B"
});

var SvgOk = function SvgOk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ok.5cba1da7.svg";
export { ForwardRef as ReactComponent };